import { metaData, registerImageLoader } from '@cornerstonejs/core';
import loadImage from './loadImage.js';
import { metaDataProvider } from './metaData/index.js';
import { logging, registerDefaultProviders } from '@cornerstonejs/metadata';
const log = logging.loaderLog.getLogger('wadors');
export default function (options) {
    registerImageLoader('wadors', loadImage);
    if (options?.useLegacyMetadataProvider) {
        log.warn('wadors metaDataProvider is deprecated. Use addDicomWebInstance from @cornerstonejs/metadata instead.');
        metaData.addProvider(metaDataProvider);
        return;
    }
    registerDefaultProviders();
    metaData.addProvider(metaDataProvider);
}
